<template lang="pug">
div
  v-row.pb-2.pb-md-0.mt-4(no-gutters)
    v-col(cols="12" md="9")
      v-tabs(v-model="tabs" color="basic700" :height="44" show-arrows active-class="font-semibold" @change="tabChanged")
        v-tab.text-sm.font-medium.text-none All
        template(v-if="offer" v-for="(segment, idx) in offer.groups")
          v-tab.text-sm.font-medium.text-none(:key="`sg-${idx}`") {{ segment.title }}
    v-col(cols="12" md="3" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
  v-divider

  audience-filter-row.my-4(:filters.sync="filters" ref="filter")
  .data-table
    v-data-table.mt-sm-4.pb-6(:headers="headers" :items="audiences" item-key="id-index" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :header-props="{ sortIcon: '$yzi-triangle' }")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:item.name="{ item }")
        div.text-sm.neutral700--text {{ item.name }}  
      template(v-slot:item.frequency="{ item }")
        div.text-sm.font-medium.neutral700--text {{ item.success_count + item.failed_count }}
      template(v-slot:item.successful="{ item }")
        div.text-sm.font-medium.neutral700--text {{ item.success_count }}
      template(v-slot:item.unsuccessful="{ item }")
        div.text-sm.font-medium(:class="item.failed_count ? 'danger500--text' : 'neutral700--text'") {{ item.failed_count }}

  div.d-flex.align-center(v-if="!tabs && totalCount > pageSize")
    v-spacer
    yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import AudienceFilterRow from '@/components/clinic/marketing/filters/AudienceFilterRow.vue'

export default {
  components: { AudienceFilterRow },
  props: {
    blastData: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      showSearchField: false,
      isFetching: false,
      tabs: 0,
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      searchText: null,
      audiences: [],
      filters: [],
      headers: [
        { value: 'name', text: 'name', class: 'text-table-header'},
        { value: 'frequency', text: 'frequency set', class: 'text-table-header'},
        { value: 'successful', text: 'successful', class: 'text-table-header'},
        { value: 'unsuccessful', text: 'unsuccessful', class: 'text-table-header'},
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer',
    }),
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.fetchFirstPage()
      }
    }
  },
  mounted () {
    this.fetchAudiences()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchAudiences () {
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage
      }
      if (this.searchText) {
        params.search = this.searchText
      }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      if (this.tabs) {
        let idx = this.tabs - 1
        params.groups = this.offer.groups[idx].id
      }
      this.$axios.get(`/marketing/${this.company.slug}/blasts/${this.blastData.id}/audiences`, { params })
        .then(resp => {
          this.totalCount = resp.data.count
          this.audiences = resp.data.results.map((m, idx) => { return { ...m, index: idx } })
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    pageChanged () {
      this.fetchAudiences()
    },
    tabChanged () {
      this.searchText = null
      this.fetchFirstPage()
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchAudiences()
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>